import React, { useState, useEffect } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;
const hhmm = (iso) => (iso ? new Date(iso).toLocaleTimeString('el-GR', { hour: '2-digit', minute: '2-digit', hour12: false }) : '—');

const Row = ({ r }) => {
  const why = r.plays === 0
    ? 'κανένα τραγούδι σήμερα'
    : r.silent_now_min >= 15
      ? `κανένας server δεν τον καταγράφει εδώ και ${r.silent_now_min}΄`
      : `μεγαλύτερο κενό ${r.max_gap_min}΄ (από ${hhmm(r.max_gap_from)})`;
  return (
    <div className="flex justify-between gap-2" data-testid={`today-station-${r.station_id}`}>
      <span className="truncate"><b>{r.station}</b>: {why}</span>
      <span className="text-gray-500 whitespace-nowrap">{r.plays} τραγ. · 1ο στο {r.first_song_min ?? '—'}΄</span>
    </div>
  );
};

export const TodaySection = ({ token, onLoaded }) => {
  const [d, setD] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const res = await fetch(`${API}/api/diagnostic/fleet-servers/today`, { headers: { Authorization: `Bearer ${token}` } });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const j = await res.json();
        if (!cancelled) { setD(j); setError(null); onLoaded?.(j); }
      } catch (e) {
        if (!cancelled) setError(e.message);
      }
    };
    load();
    const t = setInterval(load, 120000);
    return () => { cancelled = true; clearInterval(t); };
  }, [token, onLoaded]);

  if (error) return <div className="text-xs text-red-600" data-testid="today-error">Σφάλμα: {error}</div>;
  if (!d) return null;
  if (d.status === 'before_window') return <div className="text-[11px] text-gray-500 mb-2" data-testid="today-before-window">Η καταγραφή ξεκινά στις 06:00.</div>;
  const p = d.problem_stations || [];
  return (
    <div className="border border-gray-200 dark:border-gray-700 rounded-md p-2.5 text-[11px] mb-2 bg-white dark:bg-gray-900" data-testid="today-section">
      <div className="text-[10px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400 mb-1">
        Σήμερα από τις 06:00 · τελικό αποτέλεσμα στη βάση
      </div>
      <div className="text-gray-700 dark:text-gray-300 space-y-0.5" data-testid="today-summary">
        <div>Σταθμοί με τραγούδι σήμερα: <b>{d.stations_with_song}</b> από {d.stations_active}
          {d.median_first_song_min != null && <> · μισό των σταθμών έγραψε το πρώτο τραγούδι έως τις {hhmm(new Date(new Date(d.window_start).getTime() + d.median_first_song_min * 60000).toISOString())}</>}
        </div>
        <div className={d.silent_now_nobody_recording ? 'text-red-600 dark:text-red-400' : ''} data-testid="today-silent-now">
          Τώρα δεν καταγράφονται από κανέναν server (πάνω από 15΄): <b>{d.silent_now_nobody_recording}</b>
        </div>
        <div data-testid="today-gaps">Σταθμοί με κενό 20΄ ή περισσότερο σήμερα: <b>{d.stations_gap_over_20_min}</b> · χωρίς κανένα τραγούδι: <b>{d.stations_without_song}</b></div>
      </div>
      {p.length > 0 && (
        <div className="max-h-40 overflow-y-auto mt-1.5 space-y-0.5 text-gray-700 dark:text-gray-300" data-testid="today-problem-list">
          {p.map((r) => <Row key={r.station_id} r={r} />)}
        </div>
      )}
      <div className="text-gray-400 mt-1" data-testid="today-accuracy">{d.accuracy}</div>
    </div>
  );
};
